<template>
  <div>
    <DisposalOrdersHead
        :countFilterParams="countFilterParams"
        :showFilter="showFilter"
        @toggleFilter="toggleFilter"
        @filter="$emit('filter')"
        @reload="$emit('reload')"
    />

    <div class="table-filter-wrap">

      <DisposalOrdersFilter
          :showFilter="showFilter"
          :filterGetParams="filterGetParams"
          @close="closeFilter"
          @changeFilter="data => $emit('changeFilter', data)"
          @resetFilter="$emit('resetFilter')"
      />

      <DisposalOrdersTable
          :countFilterParams="countFilterParams"
          @showMore="$emit('showMore')"
          @resetFilter="$emit('resetFilter')"
          @updateTable="$emit('updateTable')"
          @reload="$emit('reload')"
      />
    </div>
  </div>
</template>

<script>

  import DisposalOrdersHead from "./DisposalOrdersHead/DisposalOrdersHead";
  import DisposalOrdersFilter from "./DisposalOrdersFilter/DisposalOrdersFilter";
  import DisposalOrdersTable from "./DisposalOrdersTable/DisposalOrdersTable";

  export default {
    name: "DisposalOrdersTableUser",

    components: {
      DisposalOrdersHead,
      DisposalOrdersFilter,
      DisposalOrdersTable,
    },

    props: {
      countFilterParams: Number,
      filterGetParams: Object,
    },

    data(){
      return {
        showFilter: false,
      }
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },
    }
  }
</script>

<style scoped>

</style>
